document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.section-secure .card-item');

    cards.forEach(card => {
        card.addEventListener('mouseenter', () => {
            cards.forEach(c => c.classList.remove('is-active'));
            card.classList.add('is-active');
        });
    });

    const container = document.querySelector('.section-secure .cards-container');
    container.addEventListener('mouseleave', () => {
        cards.forEach(c => c.classList.remove('is-active'));
        cards[0].classList.add('is-active');
    });
});